import React, { useEffect, useState } from 'react'
import { Row, Col, Container, Card, Button, Form } from 'react-bootstrap';
import Stepper from '../../component/stepper/Stepper';
import { useNavigate, useLocation } from 'react-router-dom';
import ChangeTemplateLayout from '../../component/changetemplate/ChangeTemplateLayout';
import PersonalDetailsModal from '../../component/finalizecomponent/PersonalDetailsModal';
import WebsitePortfolioModal from '../../component/finalizecomponent/WebsitePortfolioModal';
import AccomplishmentsModal from '../../component/finalizecomponent/AccomplishmentsModal';
import AffiliationsModal from '../../component/finalizecomponent/AffiliationsModal';
import AdditionalInformationModal from '../../component/finalizecomponent/AdditionalInformationModal';
import LanguagesModal from '../../component/finalizecomponent/LanguagesModal';
import CertificationsModal from '../../component/finalizecomponent/CertificationsModal';
import InterestsModal from '../../component/finalizecomponent/InterestsModal';
import HobbiesModal from '../../component/finalizecomponent/HobbiesModal';
import { setItem, removeSetItem, getItem } from '../../config/localStorage';
import PreviewTemplate from '../../component/preview/PreviewTemplate';

function Finalize() {

    const [personalDetailsModalShow, setPersonalDetailsModalShow] = useState(false);
    const [WebsitePortfolioModalShow, setWebsitePortfolioModalShow] = useState(false);
    const [AccomplishmentsModalShow, setAccomplishmentsModalShow] = useState(false);
    const [AffiliationsModalShow, setAffiliationsModalShow] = useState(false);
    const [AdditionalInformationModalShow, setAdditionalInformationModalShow] = useState(false);
    const [LanguagesModalShow, setLanguagesModalShow] = useState(false);
    const [CertificationsModalShow, setCertificationsModalShow] = useState(false);
    const [InterestsModalShow, setInterestsModalShow] = useState(false);
    const [HobbiesModalShow, setHobbiesModalShow] = useState(false);

    const [checkedPersonalDetails, setPersonalDetailsChecked] = useState(getItem('personalDetails') || false);
    const [checkedWebPortProfile, setWebPortProfileChecked] = useState(getItem('webPortProfile') || false);
    const [checkedAccomplishments, setAccomplishmentsChecked] = useState(getItem('accomplishments', true) || false);
    const [checkedAffiliations, setAffiliationsChecked] = useState(getItem('affiliations', true) || false);
    const [checkedAdditionalInformation, setAdditionalInformationChecked] = useState(getItem('additionalInformation', true) || false);
    const [checkedLanguages, setLanguagesChecked] = useState(getItem('languages', true) || false);
    const [checkedCertifications, setCertificationsChecked] = useState(getItem('certifications', true) || false);
    const [checkedInterests, setInterestsChecked] = useState(getItem('interests', true) || false);
    const [checkedHobbies, setHobbiesChecked] = useState(getItem('hobbies', true) || false);
    const [profileBtn, setProfileBtn] = useState(false)
    const [webBtn, setWebBtn] = useState(false)
    const [LanBtn, setLanBtn] = useState(false)
    const [personalCheckbox, setPersonalCheckbox] = useState()

    const navigate = useNavigate();
    const location = useLocation();

    /** to handle next and previous click button start */

    const BackSummaryPage = () => {
        navigate('/summary', { state: { summaryFieldsTwo: true } });
    }

    const goReviewResumePage = () => {
        navigate('/review-resume', { state: { setReviewResume: true } });
    }

    /** to handle next and previous click button end  */

    useEffect(() => {


        if (location.state === null || location.state.moveFinalizePage === false) {
            navigate('/resume-builder');
        }
        // Persondetails page function
        // if (getItem("personalDetails")) {
        //     if (JSON.parse(getItem('personalDetailsData'))?.dob === undefined) {
        //         setProfileBtn(() => true)
        //     } else {
        //         setProfileBtn(() => false)
        //     }
        // }
        // else {
        //     setProfileBtn(() => false)
        // }
        // WebportProfile page function
        if (getItem("webPortProfile")) {
            if (JSON.parse(getItem('webPortProfileData'))?.wpLinkOne === undefined) {
                setWebBtn(() => true)
            } else {
                setWebBtn(() => false)
            }
        }
        else {
            setWebBtn(() => false)
        }
        //Language page function
        if (getItem("languages")) {
            if (getItem('languagesData') === null) {
                setLanBtn(() => true)
            } else {
                setLanBtn(() => false)
            }
        }
        else {
            setLanBtn(() => false)
        }

    }, [personalCheckbox]);
    const handleCheckboxChange = (checkbox) => {
        switch (checkbox) {
            case 'personalDetails':
                setPersonalDetailsChecked(!checkedPersonalDetails);
                if (checkedPersonalDetails === false) {
                    setItem('personalDetails', true);
                    setPersonalCheckbox((prev) => !prev)
                } else {
                    removeSetItem('personalDetails');
                    setPersonalCheckbox((prev) => !prev)
                }
                break;
            case 'webPortProfile':
                setWebPortProfileChecked(!checkedWebPortProfile);
                if (checkedWebPortProfile === false) {
                    setItem('webPortProfile', true);
                    setPersonalCheckbox((prev) => !prev)
                } else {
                    removeSetItem('webPortProfile');
                    setPersonalCheckbox((prev) => !prev)
                }
                break;
            case 'accomplishments':
                setAccomplishmentsChecked(!checkedAccomplishments);
                if (checkedAccomplishments === false) {
                    setItem('accomplishments', true);
                    setPersonalCheckbox((prev) => !prev);
                } else {
                    removeSetItem('accomplishments');
                    setPersonalCheckbox((prev) => !prev)
                }
                break;
            case 'affiliations':
                setAffiliationsChecked(!checkedAffiliations);
                if (checkedAffiliations === false) {
                    setItem('affiliations', true);
                } else {
                    removeSetItem('affiliations');
                }
                break;
            case 'additionalInformation':
                setAdditionalInformationChecked(!checkedAdditionalInformation);
                if (checkedAdditionalInformation === false) {
                    setItem('additionalInformation', true);
                } else {
                    removeSetItem('additionalInformation');
                }
                break;
            case 'languages':
                setLanguagesChecked(!checkedLanguages);
                if (checkedLanguages === false) {
                    setItem('languages', true);
                    setPersonalCheckbox((prev) => !prev)
                } else {
                    removeSetItem('languages');
                    setPersonalCheckbox((prev) => !prev)
                }
                break;
            case 'certifications':
                setCertificationsChecked(!checkedCertifications);
                if (checkedCertifications === false) {
                    setItem('certifications', true);
                } else {
                    removeSetItem('certifications');
                }
                break;
            case 'interests':
                setInterestsChecked(!checkedInterests);
                if (checkedInterests === false) {
                    setItem('interests', true);
                } else {
                    removeSetItem('interests');
                }
                break;
            case 'hobbies':
                setHobbiesChecked(!checkedHobbies);
                if (checkedHobbies === false) {
                    setItem('hobbies', true);
                } else {
                    removeSetItem('hobbies');
                }
                break;
            default:
                break;
        }
    };

    return (
        <>
            <section className='main-section padding-top-bottom finalize-main-section'>
                <Container>
                    <Row>
                        <Col md={12}>
                            <Card className='finalize-card-option shadow border-0'>
                                <Stepper pagenumber='6' />

                                < Card.Body className='finalize-part-one-main'>
                                    <Row>
                                        <Col md={12} className='finalize-part-one-text-outer'>
                                            <div className='finalize-part-one-text'>
                                                <h2>Do you have anything else to add?</h2>
                                                <p>These sections are optional</p>
                                            </div>
                                        </Col>
                                        <Col md={8} className='finalize-part-one-text-outer col-xl-9'>

                                            <Col md={12} className='finalize-checkbox'>
                                                <Form.Check
                                                    type='checkbox'
                                                    id='finalize-personal-details'
                                                    label='Personal Details'
                                                    checked={getItem('personalDetails') ? true : checkedPersonalDetails}
                                                    onChange={() => handleCheckboxChange('personalDetails')}
                                                />
                                                {(getItem('personalDetails') || checkedPersonalDetails) ? <i className="fa-regular fa-pen-to-square cus-edit-btn" onClick={() => setPersonalDetailsModalShow(true)}></i> : ''}
                                            </Col>

                                            <Col md={12} className='finalize-checkbox'>
                                                <Form.Check
                                                    type='checkbox'
                                                    id='finalize-web-port-profile'
                                                    label='Websites, Portfolios, Profiles'
                                                    checked={getItem('webPortProfile') ? true : checkedWebPortProfile}
                                                    onChange={() => handleCheckboxChange('webPortProfile')}
                                                />
                                                {(getItem('webPortProfile') || checkedWebPortProfile) ? <i className="fa-regular fa-pen-to-square cus-edit-btn" onClick={() => setWebsitePortfolioModalShow(true)}></i> : ''}
                                            </Col>

                                            <Col md={12} className='finalize-checkbox'>
                                                <Form.Check
                                                    type='checkbox'
                                                    id='finalize-accomplishments'
                                                    label='Accomplishments'
                                                    checked={getItem('accomplishments') ? true : checkedAccomplishments}
                                                    onChange={() => handleCheckboxChange('accomplishments')}
                                                />
                                                {(getItem('accomplishments') || checkedAccomplishments) ? <i className="fa-regular fa-pen-to-square cus-edit-btn" onClick={() => setAccomplishmentsModalShow(true)}></i> : ''}
                                            </Col>

                                            <Col md={12} className='finalize-checkbox'>
                                                <Form.Check
                                                    type='checkbox'
                                                    id='finalize-affiliations'
                                                    label='Affiliations'
                                                    checked={getItem('affiliations') ? true : checkedAffiliations}
                                                    onChange={() => handleCheckboxChange('affiliations')}
                                                />
                                                {(getItem('affiliations') || checkedAffiliations) ? <i className="fa-regular fa-pen-to-square cus-edit-btn" onClick={() => setAffiliationsModalShow(true)}></i> : ''}
                                            </Col>

                                            <Col md={12} className='finalize-checkbox'>
                                                <Form.Check
                                                    type='checkbox'
                                                    id='finalize-additional-infromation'
                                                    label='Additional Information'
                                                    checked={getItem('additionalInformation') ? true : checkedAdditionalInformation}
                                                    onChange={() => handleCheckboxChange('additionalInformation')}
                                                />
                                                {(getItem('additionalInformation') || checkedAdditionalInformation) ? <i className="fa-regular fa-pen-to-square cus-edit-btn" onClick={() => setAdditionalInformationModalShow(true)}></i> : ''}
                                            </Col>

                                            <Col md={12} className='finalize-checkbox'>
                                                <Form.Check
                                                    type='checkbox'
                                                    id='finalize-languages'
                                                    label='Languages'
                                                    checked={getItem('languages') ? true : checkedLanguages}
                                                    onChange={() => handleCheckboxChange('languages')}
                                                />
                                                {(getItem('languages') || checkedLanguages) ? <i className="fa-regular fa-pen-to-square cus-edit-btn" onClick={() => setLanguagesModalShow(true)}></i> : ''}
                                            </Col>

                                            <Col md={12} className='finalize-checkbox'>
                                                <Form.Check
                                                    type='checkbox'
                                                    id='finalize-certifications'
                                                    label='Certifications'
                                                    checked={getItem('certifications') ? true : checkedCertifications}
                                                    onChange={() => handleCheckboxChange('certifications')}
                                                />
                                                {(getItem('certifications') || checkedCertifications) ? <i className="fa-regular fa-pen-to-square cus-edit-btn" onClick={() => setCertificationsModalShow(true)}></i> : ''}
                                            </Col>

                                            <Col md={12} className='finalize-checkbox'>
                                                <Form.Check
                                                    type='checkbox'
                                                    id='finalize-interests'
                                                    label='Interests'
                                                    checked={getItem('interests') ? true : checkedInterests}
                                                    onChange={() => handleCheckboxChange('interests')}
                                                />
                                                {(getItem('interests') || checkedInterests) ? <i className="fa-regular fa-pen-to-square cus-edit-btn" onClick={() => setInterestsModalShow(true)}></i> : ''}
                                            </Col>

                                            <Col md={12} className='finalize-checkbox'>
                                                <Form.Check
                                                    type='checkbox'
                                                    id='finalize-hobbies'
                                                    label='Hobbies'
                                                    checked={getItem('hobbies') ? true : checkedHobbies}
                                                    onChange={() => handleCheckboxChange('hobbies')}
                                                />
                                                {(getItem('hobbies') || checkedHobbies) ? <i className="fa-regular fa-pen-to-square cus-edit-btn" onClick={() => setHobbiesModalShow(true)}></i> : ''}
                                            </Col>

                                        </Col>
                                        <Col md={4} className='col-xl-3'>
                                            <ChangeTemplateLayout />
                                        </Col>

                                        <Col md={12}>
                                            <Col className='next-prev-btn-section col-md-12'>
                                                <Row>
                                                    <Col md={12} className='form-mid-section'>
                                                        <Button className='my-previous-btn float-start' onClick={BackSummaryPage}>Back</Button>
                                                        <PreviewTemplate />
                                                        <Button className='my-next-btn button-green float-end' onClick={goReviewResumePage} disabled={profileBtn || webBtn || LanBtn}>Next</Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Col>
                                    </Row>
                                </Card.Body>

                            </Card>
                        </Col>
                    </Row>
                </Container >
            </section >

            <PersonalDetailsModal
                show={personalDetailsModalShow}
                onHide={() => setPersonalDetailsModalShow(false)}
                setPersonalCheckbox={setPersonalCheckbox}
            />

            <WebsitePortfolioModal
                show={WebsitePortfolioModalShow}
                onHide={() => setWebsitePortfolioModalShow(false)}
                setPersonalCheckbox={setPersonalCheckbox}
            />
            <AccomplishmentsModal
                show={AccomplishmentsModalShow}
                onHide={() => setAccomplishmentsModalShow(false)}
            />
            <AffiliationsModal
                show={AffiliationsModalShow}
                onHide={() => setAffiliationsModalShow(false)}
            />
            <AdditionalInformationModal
                show={AdditionalInformationModalShow}
                onHide={() => setAdditionalInformationModalShow(false)}
            />
            <LanguagesModal
                show={LanguagesModalShow}
                onHide={() => setLanguagesModalShow(false)}
                setPersonalCheckbox={setPersonalCheckbox}
            />
            <CertificationsModal
                show={CertificationsModalShow}
                onHide={() => setCertificationsModalShow(false)}
            />
            <InterestsModal
                show={InterestsModalShow}
                onHide={() => setInterestsModalShow(false)}
            />
            <HobbiesModal
                show={HobbiesModalShow}
                onHide={() => setHobbiesModalShow(false)}
            />

        </>
    )
}


export default Finalize
